import { css as l } from "styled-components";
const c = {
  base: () => /* @__PURE__ */ l([
    "display:inline-flex;align-items:center;"
  ]),
  light: ({ theme: o }) => /* @__PURE__ */ l([
    "color:",
    ";svg{color:",
    ";}&:hover{color:",
    ";svg{color:",
    ";}}"
  ], o.colors.global.white, o.colors.global.white, o.colors.global.white, o.colors.global.white),
  dark: ({ theme: o }) => /* @__PURE__ */ l([
    "svg{color:",
    ";}&:hover{svg{color:",
    ";}}"
  ], o.componentColors.backButton.iconColor, o.componentColors.backButton.iconColorHover)
};
export {
  c as default
};
